import {
  INLINE_FILE_REQUEST_RENDERER_KEY,
} from "@/Utile/ncrmExternalFormRenderers.mjs";
import {
  normalizeFileRequestFormats,
  normalizeFileRequestLocales,
} from "@/Utile/ncrmExternalFileFormConfig.mjs";

import { privacyPayload } from "@/Utile/ncrmExternalFormPrivacy.mjs";
import { privacyFieldsPayload } from "@/Utile/ncrmExternalDataCollectionForm.mjs";

const clone = (value) => JSON.parse(JSON.stringify(value));

export const buildExternalFormWidgetPayloadConfig = (form = {}, defaults) => {
  const rendererKey = defaults.rendererKeys.includes(form.rendererKey || form.displayConfig?.rendererKey)
    ? form.rendererKey || form.displayConfig?.rendererKey
    : defaults.rendererKey;
  return {
    workflow_instance_id: form.workflow_instance_id || form.workflowInstanceId,
    endpoint_id: Number(form.endpoint_id || form.endpointId) || null,
    form_key: String(form.form_key || form.formKey || "").trim(),
    name: String(form.name || "").trim(),
    status: defaults.statuses.includes(form.status) ? form.status : "draft",
    allowedOrigins: Array.isArray(form.allowedOrigins) ? form.allowedOrigins : [...defaults.origins],
    displayConfig: {
      ...clone(defaults.displayConfig),
      ...(form.displayConfig || {}),
      rendererKey,
      delaySeconds: Math.max(0, Number.parseInt(form.displayConfig?.delaySeconds, 10) || 0),
      repeatAfterHours: Math.max(1, Number.parseInt(form.displayConfig?.repeatAfterHours, 10) || 24),
      includePages: Array.isArray(form.displayConfig?.includePages) ? form.displayConfig.includePages : ["*"],
      excludePages: Array.isArray(form.displayConfig?.excludePages) ? form.displayConfig.excludePages : [],
      allowedFileExtensions: normalizeFileRequestFormats(form.displayConfig?.allowedFileExtensions),
    },
    content: {
      ...clone(form.content || defaults.content),
      fileRequestLocales: normalizeFileRequestLocales(form.content?.fileRequestLocales),
    },
    theme: clone(form.theme || defaults.theme),
    fields: clone(form.fields || defaults.fields),
    channels: clone(form.channels || defaults.channels),
    consent: {
      ...clone(defaults.consent),
      ...(form.consent || {}),
      required: form.consent?.required !== false,
      label: rendererKey === INLINE_FILE_REQUEST_RENDERER_KEY
        ? defaults.consent.label
        : form.consent?.label || defaults.consent.label,
      // S5.1 — maparea Privacy; `null` elimină configul stocat.
      privacy: privacyPayload(form.privacy),
      // S5.3B — mapările per câmp ale formularului „Colectare date”.
      privacy_fields: privacyFieldsPayload(form.privacyFields),
    },
    notifications: {
      email: {
        ...clone(defaults.notifications.email),
        ...(form.notifications?.email || {}),
        enabled: Boolean(form.notifications?.email?.enabled),
        to: Array.isArray(form.notifications?.email?.to) ? form.notifications.email.to : [],
        cc: Array.isArray(form.notifications?.email?.cc) ? form.notifications.email.cc : [],
      },
      telegram: {
        enabled: Boolean(form.notifications?.telegram?.enabled),
        recipientUserIds: Array.isArray(form.notifications?.telegram?.recipientUserIds)
          ? form.notifications.telegram.recipientUserIds
          : [],
      },
    },
  };
};
